import { Routes } from '@angular/router';

import { SHELL_ROUTES } from './shell/shell.routes';
import { ContextualNotFoundComponent } from './shared/components/contextual-not-found/contextual-not-found.component';
import { mobileAdminGuard } from './mobile-admin/mobile-admin.guard';
import { sysadminGuard } from './sysadmin/sysadmin.guard';

export const APP_ROUTES: Routes = [
  // The analytics shell first: its tree must match ahead of the redirect and catch-all below.
  ...SHELL_ROUTES,
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    // The Connector Manager moved under /analytics/connectors (it is a
    // client-facing Analytics view); these keep old deep links and bookmarks
    // working.
    path: 'connector-manager',
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/analytics/connectors' },
      {
        path: ':connectorId/rule/:ruleId',
        redirectTo: '/analytics/connectors/:connectorId/rule/:ruleId',
      },
      {
        path: ':connectorId',
        redirectTo: '/analytics/connectors/:connectorId',
      },
    ],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    data: {
      section: 'admin',
    },
  },
  {
    path: 'source-catalog',
    loadChildren: () =>
      import('./source-catalog/source-catalog.routes').then(
        (m) => m.SOURCE_CATALOG_ROUTES,
      ),
    data: {
      section: 'source-catalog',
    },
  },
  {
    path: 'sysadmin',
    canMatch: [sysadminGuard],
    loadChildren: () =>
      import('./sysadmin/sysadmin.routes').then((m) => m.SYSADMIN_ROUTES),
    data: {
      section: 'sysadmin',
    },
  },
  {
    path: 'design-system',
    loadChildren: () =>
      import('./design-system/design-system.routes').then(
        (m) => m.DESIGN_SYSTEM_ROUTES,
      ),
  },
  {
    path: 'mobile-admin',
    canMatch: [mobileAdminGuard],
    loadChildren: () =>
      import('./mobile-admin/mobile-admin.routes').then(
        (m) => m.MOBILE_ADMIN_ROUTES,
      ),
    data: {
      section: 'mobile-admin',
    },
  },
  {
    path: '',
    redirectTo: '/analytics/home',
    pathMatch: 'full',
  },
  // ! here is the Catch-all Route for completely invalid paths -> after the shell routes
  { path: '**', component: ContextualNotFoundComponent },
];
